import type { FaireProductEntity } from "../../entity_types/product";

export const p_crp67dpf7u: FaireProductEntity = {
  token: "p_crp67dpf7u",
  type: "product",
  name: "Essential Pullover Sweater Top",
  brandToken: "b_y45d6be4by",
  brandName: "Mimosa",
  imageUrl:
    "https://cdn.faire.com/fastly/0c2fd5722afadadf0dbbe58aaa417a1414497dc128e00ee189fb113f6d695f6e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b721baa655699a065d12ee8357dc1591469a5d2098cfa7d7134ea91dd947132a.jpeg",
    "https://cdn.faire.com/fastly/2814c39e5613220e88ca0bdb6586ac95445720188df25a8d73d2592e4515c0cf.jpeg",
    "https://cdn.faire.com/fastly/a31d2d830bdc396fd178c4a1609cf40c947852d5d80286f02cc4c957289d64eb.jpeg",
    "https://cdn.faire.com/fastly/f4af59df76b7795eb6b39cec46cef6c377a5ec360a4cd0ab6e243d8170983972.jpeg",
    "https://cdn.faire.com/fastly/afe573ed0dac1ce10b99861770b0c94d0f977f68d49921f1aaa74bce4dd63a3b.jpeg",
    "https://cdn.faire.com/fastly/4d167c30a52032d3a7822cea8ac80b6594164f0e7c06d0f0d80da8383f1b4914.jpeg",
    "https://cdn.faire.com/fastly/115241f2eb006cf443192f50c94c0278f7b7d273be193ee0bb8cbf0550f52653.jpeg",
    "https://cdn.faire.com/fastly/205ae230e86037fceeb1d7689f164bce94d4c1c00260feb7054f79bfaf9ede10.jpeg",
    "https://cdn.faire.com/fastly/8112b4aca56a2a019e82f22d135180e87357ed8b6a1e17310643e706d949133a.jpeg",
    "https://cdn.faire.com/fastly/ca111ad32468d35c65a88c0aab96ea7404fe500a6e6d1378c5268d8bbeabe37f.jpeg",
    "https://cdn.faire.com/fastly/c173a7ba588612f674daf439b005c64044d0ac660ad4c0bd5a0857a0511637ed.jpeg",
    "https://cdn.faire.com/fastly/67f0be794a3ddaabc526c193452c3e6a59e719b65e88c644b9afa7a60f950241.jpeg",
    "https://cdn.faire.com/fastly/7067d65370aa1885b3e151ca9931c3201f369bcbdb97c48949b96a0ba6218950.jpeg",
    "https://cdn.faire.com/fastly/3bc8b18527b7b9894954345ee94d858498b824d20d19503075d9cc3c2f288d0a.jpeg",
    "https://cdn.faire.com/fastly/f121d3d08ef1e4184684c3d39d1e5933bd24ccafad5de5ab949694c4d955ab90.jpeg",
    "https://cdn.faire.com/fastly/77b63ebfe067d1c8553be68b9de14ab36207b8e9d4e6a4fbb6ca1cc2d57b37b9.jpeg",
    "https://cdn.faire.com/fastly/39295f6e912d4ba726f5c9feb450036423de74e6fb2f16afde208e0fe75f5c1a.jpeg",
  ],
  priceDollars: 117,
  description:
    "A cozy twist on our bestselling cardigan - without the buttons. This essential long sleeve knit sweater features a rolled collar, relaxed silhouette, and dropped shoulders for a casual yet elevated feel. Crafted from the same super soft, lightweight knit, it includes a rolled hem and a clean finish that makes it perfect for layering or wearing solo. Designed to be effortlessly wearable year-round, this easy pullover is a must-have in every color.\nMK7124\n\nWomens Clothing, Fall, Winter, Spring, Sweater, Lightweight, Pullover, Relaxed Fit, Basic, Soft Knit, Casual, Loungewear, New Arrivals, Essentials, Resort, Vacation, Year-Round, Fall 2026, Winter 2026, Everyday",
  tags: [],
  msrpDollars: 234,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:55.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
